import { render, staticRenderFns } from "./FormattedMinutesComponent.vue?vue&type=template&id=198229a7&"
import script from "./FormattedMinutesComponent.vue?vue&type=script&lang=js&"
export * from "./FormattedMinutesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports